<template>
  <!-- BEGIN CONTENT BODY -->
  <!-- BEGIN PAGE HEADER-->
  <div>
    <breadcrumb-bar :crumbs="['Manage Account']"></breadcrumb-bar>
    <!-- END PAGE HEADER-->
    <div class="col-md-12">
      <div class="row">
        <transition name="fade">
          <router-view></router-view>
        </transition>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  export default {
    components: {
      'breadcrumb-bar': Breadcrumbs
    }
  }
</script>



// WEBPACK FOOTER //
// ManageAccount.vue?6169ca82